import { RefObject, useEffect, useRef, useState } from 'react';
import { usePushdownContext } from '../providers/Pushdown/PushdownProvider';
import { AcquisitionFlow, clearSessionStorageVariablesForAcquisitionFlow, getAcquisitionFlow, getCurrentlyInAcquisitionFlow, getDataEntryPages, handlePartnerRedirect } from '../utils/acquisition-utils';
import SessionStorage, { clearAquisitionData } from '../utils/SessionStorage';
/**
 * shows pushdown after user is idle for 15 min
 */
export default function useSessionTimeout(refToPage: RefObject<HTMLElement>, flow: AcquisitionFlow = getAcquisitionFlow()) {
    const timer = useRef<NodeJS.Timeout | null>(null);
    /**
     * value comes from legacy codebase
     * 15 minutes (milliseconds)
     */
    const [ idleTimeout ] = useState<number>(SessionStorage.tryGet('useTimeout', 9e5));
    const { showPushdown } = usePushdownContext();
    const dataEntryPages = getDataEntryPages();

    const start = () => {
        if (getCurrentlyInAcquisitionFlow()) {
            if (!window.frameElement) {
                if (timer.current) {
                    clearTimeout(timer.current);
                }
            
                timer.current = setTimeout(() => {
                    
                    SessionStorage.setObject('hasExpired', true);
                    
                    if (flow === AcquisitionFlow.PHA || flow === AcquisitionFlow.PqOfOne) {
                        clearSessionStorageVariablesForAcquisitionFlow();
                        handlePartnerRedirect();
                        return;
                    }
                    const flowURL = {
                        [AcquisitionFlow.PQ]: dataEntryPages.preQualDataEntryPageUrl,
                        [AcquisitionFlow.PA]: dataEntryPages.preApprovalDataEntryPageUrl,
                        [AcquisitionFlow.SkipPQ]: dataEntryPages.skipPreQualDataEntryPageUrl,
                    }[flow];

                    clearSessionStorageVariablesForAcquisitionFlow();
                    if (window.location.href.includes('4502')) {
                        window.location.replace('/content/cob-corp-acquisition/us/en' + flowURL + window.location.search);
                    } else {
                        
                        window.location.replace(flowURL + window.location.search);
                    }
                }, idleTimeout);
            }
        } else {
            if (timer.current) {
                clearTimeout(timer.current);
            }
            timer.current = setTimeout(() => {
                clearAquisitionData();
                SessionStorage.setObject('hasExpired', true);
                window.location.reload();
            }, idleTimeout); 
        }
    };


    useEffect(() => {
        if (!window.frameElement && SessionStorage.getObject('hasExpired') === true) {
            showPushdown('/content/dam/cob-corp-acquisition/content-fragments/pushdowns/session-timeout/_jcr_content/data/master');
            SessionStorage.setObject('hasExpired', false);
        }
    }, []);

    useEffect(() => {
        if (!window.location.href.includes('localhost') && !window.location.href.includes('terms')
            && !window.location.href.includes('editor') && !window.location.href.includes('4502')) {
            if (refToPage.current) {
                const page = refToPage.current;

                page.addEventListener('pointermove', start);
                page.addEventListener('keydown', start);
                page.addEventListener('mousedown', start);
                
                if (SessionStorage.contains('hasExpired') === null) {
                    SessionStorage.setObject('hasExpired', false);
                }

                start();

                return () => {
                    if (page) {
                        page.removeEventListener(
                            'pointermove',
                            start,
                        );
                        page.removeEventListener(
                            'keydown',
                            start,
                        );
                        page.removeEventListener(
                            'mousedown',
                            start,
                        );   
                    }

                    if (timer.current) {
                        clearTimeout(timer.current);
                    }
                };
            }
        }
    }, [start, refToPage]);
}